import * as _ from "lodash";
import {Button} from "../../models/formio/button";
import {CheckBox} from "../../models/formio/checkbox";
import {Classification} from "../../models/formio/classification";
import {Columns} from "../../models/formio/columns";
import {ComplexDataGrid} from "../../models/formio/complex-datagrid";
import {Content} from "../../models/formio/content";
import {Currency} from "../../models/formio/currency";
import {DataGrid} from "../../models/formio/data-grid";
import {DateTime} from "../../models/formio/datetime";
import {Day} from "../../models/formio/day";
import {EditGrid} from "../../models/formio/edit-grid";
import {Email} from "../../models/formio/email";
import {FileUpload} from "../../models/formio/file-upload";
import {FormioBase} from "../../models/formio/formiobase";
import { HiddenField } from "../../models/formio/hiddenfield";
import {Htmlelement} from "../../models/formio/htmlelement";
import {MyEcoActivity} from "../../models/formio/my-eco-activity";
import {MyContent} from "../../models/formio/mycontent";
import {Number} from "../../models/formio/number";
import {Phone} from "../../models/formio/phone";
import {Radio} from "../../models/formio/radio";
import {Select} from "../../models/formio/select";
import {Table} from "../../models/formio/table";
import {TextArea} from "../../models/formio/textarea";
import {TextField} from "../../models/formio/textfield";
import { environment } from "../../../environments/environment";

export default class FormUtils {

  public static convertToComponent(field: FormioBase) {
    switch (true) {
      case ("checkbox" === field.inputType):
        return new CheckBox();
      case ("text" === field.inputType):
        return new TextField();
      case ("textarea" === field.inputType):
        return new TextArea();
      case ("number" === field.inputType):
        // eslint-disable-next-line
        return new Number();
      case ("day" === field.inputType):
        return new Day();
      case ("datetime" === field.inputType):
        return new DateTime();
      case ("content" === field.inputType):
        return new Content();
      case ("mycontent" === field.inputType):
        return new MyContent();
      case ("select" === field.inputType):
        return new Select();
      case ("radio" === field.inputType):
        return new Radio();
      case ("file" === field.inputType):
        return new FileUpload();
      case ("datagrid" === field.inputType):
        return new DataGrid();
      case ("editgrid" === field.inputType):
        return new EditGrid();
      case ("complexdatagrid" === field.inputType):
        return new ComplexDataGrid();
      case ("myecoactivity" === field.inputType):
        return new MyEcoActivity();
      case ("email" === field.inputType):
        return new Email();
      case ("currency" === field.inputType):
        return new Currency();
      case ("phoneNumber" === field.inputType):
        return new Phone();
      case ("classification" === field.inputType):
        return new Classification();
      case ("table" === field.inputType):
        return new Table();
      case ("htmlelement" === field.inputType):
        return new Htmlelement();
      case ("columns" === field.inputType):
        return new Columns();
      case ("button" === field.inputType):
        return new Button();
      case ("hidden" === field.inputType):
        return new HiddenField();
      default:
        return undefined;
    }
  }

  public static getIcon(field: FormioBase) {
    switch (true) {
      case ("checkbox" === field.inputType):
        return new CheckBox().icon;
      case ("text" === field.inputType):
        return new TextField().icon;
      case ("textarea" === field.inputType):
        return new TextArea();
      case ("number" === field.inputType):
        // eslint-disable-next-line
        return new Number().icon;
      case ("day" === field.inputType):
        return new Day().icon;
      case ("datetime" === field.inputType):
        return new DateTime().icon;
      case ("content" === field.inputType):
        return new Content().icon;
      case ("mycontent" === field.inputType):
        return new MyContent().icon;
      case ("select" === field.inputType):
        return new Select().icon;
      case ("radio" === field.inputType):
        return new Radio().icon;
      case ("file" === field.inputType):
        return new FileUpload().icon;
      case ("datagrid" === field.inputType):
        return new DataGrid().icon;
      case ("editgrid" === field.inputType):
        return new EditGrid().icon;
      case ("complexdatagrid" === field.inputType):
        return new ComplexDataGrid().icon;
      case ("myecoactivity" === field.inputType):
        return new MyEcoActivity().icon;
      case ("email" === field.inputType):
        return new Email().icon;
      case ("currency" === field.inputType):
        return new Currency().icon;
      case ("phoneNumber" === field.inputType):
        return new Phone().icon;
      case ("classification" === field.inputType):
        return new Classification().icon;
      case ("table" === field.inputType):
        return new Table().icon;
      case ("htmlelement" === field.inputType):
        return new Htmlelement().icon;
      case ("columns" === field.inputType):
        return new Columns().icon;
      case ("button" === field.inputType):
        return new Button().icon;
      case ("hidden" === field.inputType):
        return new HiddenField().icon;
      default:
        return undefined;
    }
  }

  public static convertDeterminantTypeToFieldType(type: string) {
    if (type === "BOOLEAN") {
      return "boolean";
    } else if (type === "NUMERIC") {
      return "number";
    } else if (type === "SELECTION") {
      return "select";
    } else if (type === "RADIO") {
      return "radio";
    } else if (type === "DATE") {
      return "datetime";
    } else if (type === "CLASSIFICATION" || type === "SUB_CATALOG") {
      return "classification";
    } else if (type === "TEXT") {
      return "text";
    } else if (type === "MONEY") {
      return "number";
    } else {
      return "";
    }
  }

  /**
   * Generate key from title in camelCase with removed accents (like formio does)
   */
  public static generateGuideIdFromTitle(guideTitle: string) {
    if (guideTitle) {
      guideTitle = _.deburr(guideTitle);
      return _.camelCase(guideTitle);
    } else {
      throw new Error("Form title cannot be undefined!");
    }
  }

  public static updateWithVersion(comp: any) {
    comp.version = "201905";
    if (comp.components) {
      for (const child of comp.components) {
        this.updateWithVersion(child);
      }
    } else if (comp.rows && Array.isArray(comp.rows)) {
      for (const child of comp.rows) {
        if (child.components) {
          for (const entry of child.components) {
            this.updateWithVersion(entry);
          }
        } else if (Array.isArray(child)) {
          for (const item of child) {
              this.updateWithVersion(item);
            }
          }
      }
    } else if (comp.columns) {
      for (const child of comp.columns) {
        if (child.components) {
          for (const entry of child.components) {
            this.updateWithVersion(entry);
          }
        }
      }
    }
  }

  // when saving a table inside editgrid "numRows" and "numCols" disappear.
  public static updateTableAttributes(comp: any) {
    if (comp.components) {
      for (const child of comp.components) {
        this.updateTableAttributes(child);
      }
    } else if (Array.isArray(comp.rows)) {
      if (!comp.numRows) {
        comp.numRows = comp.rows.length;
      }
      if (!comp.numCols && comp.rows[0]) {
        comp.numCols = comp.rows[0].length;
      }
      for (const child of comp.rows) {
        for (const entry of child) {
          this.updateTableAttributes(entry);
        }
      }
    } else if (comp.columns) {
      for (const child of comp.columns) {
        this.updateTableAttributes(child);
      }
    }
  }

  public static updateServiceFieldsInSubComponents(comp: any, registrations: any[], refreshNeeded: boolean) {
    if (!comp.registrations) {
      comp.registrations = {};
    }
    if (registrations) {
      Object.keys(registrations).forEach((reg) => {
        if (registrations[reg] && !comp.registrations[reg]) {
          comp.registrations[reg] = true;
          refreshNeeded = true;
        }
      });
    }
    if (comp.components) {
      for (const child of comp.components) {
        refreshNeeded = this.updateServiceFieldsInSubComponents(child, comp.registrations, refreshNeeded);
      }
    } else if (comp.rows) {
      for (const child of comp.rows) {
        for (const entry of child) {
          refreshNeeded = this.updateServiceFieldsInSubComponents(entry, comp.registrations, refreshNeeded);
        }
      }
    } else if (comp.columns) {
      for (const child of comp.columns) {
        for (const entry of child) {
          refreshNeeded = this.updateServiceFieldsInSubComponents(entry, comp.registrations, refreshNeeded);
        }
      }
    }
    return refreshNeeded;
  }

  // TOBE-18006: on save, append a visible empty column completing each
  // under-12 columns row to 12 (append-only — never resizes designer
  // widths; rows with existing trailing empty columns are migration
  // territory, TOBE-18005). Flag is explicit opt-in per instance and
  // must stay off until the DS empty-column fix (DS-Frontend#173) is
  // live there. Rules mirror the reference corpus in
  // src/test/mocks/columns-fixture-corpus.mock.ts.
  private static readonly COLUMNS_EXCLUDED_KEYS = [
    "my-applications-pagination",
    "myApplicationsNavButtons",
  ];

  public static completeColumnsRows(comp: any, insideGrid = false) {
    if (environment.COLUMNS_COMPLETION_ENABLED !== "true") {
      return;
    }
    this.completeColumnsRowsInner(comp, insideGrid);
  }

  private static completeColumnsRowsInner(comp: any, insideGrid: boolean) {
    const childGrid =
      insideGrid || comp.type === "editgrid" || comp.type === "datagrid";
    if (comp.type === "columns" && Array.isArray(comp.columns)) {
      this.appendColumnsFiller(comp, insideGrid);
    }
    if (Array.isArray(comp.components)) {
      for (const child of comp.components) {
        this.completeColumnsRowsInner(child, childGrid);
      }
    }
    if (Array.isArray(comp.rows)) {
      for (const row of comp.rows) {
        const cells = Array.isArray(row) ? row : row?.components || [];
        for (const cell of cells) {
          const entries = Array.isArray(cell?.components)
            ? cell.components
            : Array.isArray(row) ? [cell] : [];
          for (const entry of entries) {
            this.completeColumnsRowsInner(entry, childGrid);
          }
        }
      }
    }
    if (Array.isArray(comp.columns)) {
      for (const column of comp.columns) {
        if (Array.isArray(column?.components)) {
          for (const entry of column.components) {
            this.completeColumnsRowsInner(entry, childGrid);
          }
        }
      }
    }
    if (Array.isArray(comp.tabs)) {
      for (const pane of comp.tabs) {
        if (Array.isArray(pane?.components)) {
          for (const entry of pane.components) {
            this.completeColumnsRowsInner(entry, childGrid);
          }
        }
      }
    }
  }

  private static appendColumnsFiller(comp: any, insideGrid: boolean) {
    if (insideGrid || !comp.key) {
      return;
    }
    const customClass = (comp.customClass || "").split(/\s+/);
    if (customClass.indexOf("adjust-columns") !== -1) {
      return;
    }
    if (this.COLUMNS_EXCLUDED_KEYS.indexOf(comp.key) !== -1) {
      return;
    }
    const columns = comp.columns as any[];
    if (!columns.length) {
      return;
    }
    const widths = columns.map((c) => c?.width);
    if (
      widths.some(
        (w) => typeof w !== "number" || w % 1 !== 0 || w < 1 || w > 12
      )
    ) {
      return;
    }
    const lastEmpty = !((columns[columns.length - 1].components || []).length);
    if (lastEmpty) {
      return; // existing spacer (right or wrong width) — append-only rule
    }
    const nonEmpty = columns.filter((c) => (c.components || []).length);
    if (!nonEmpty.length) {
      return;
    }
    const sum = widths.reduce((s, w) => s + w, 0);
    if (sum < 1 || sum >= 12) {
      return;
    }
    const sizes = nonEmpty.map((c) => c.size || "md");
    const counts: { [k: string]: number } = {};
    let dominant = sizes[0];
    for (const s of sizes) {
      counts[s] = (counts[s] || 0) + 1;
      if (counts[s] > counts[dominant]) {
        dominant = s;
      }
    }
    columns.push({
      size: dominant,
      width: 12 - sum,
      offset: 0,
      push: 0,
      pull: 0,
      components: [],
    });
  }

}
